import { AlertStatus } from '@/entities/alert-status';

export const NO_DATA_COLOR = '#9ca3af'; // Tailwind gray-400

const colorsFromAlertStatus: Record<AlertStatus, string> = {
  [AlertStatus.CRITICAL]: '#fb2c36',
  [AlertStatus.TRIPPED]: '#A97B50',
  [AlertStatus.WARNING]: '#efb100',
  [AlertStatus.INFO]: '#86DFC2',
  [AlertStatus.OK]: '#00bc7d',
};

export function alertStatusColor(alertStatus: AlertStatus | null): string {
  if (!alertStatus) return NO_DATA_COLOR;
  return colorsFromAlertStatus[alertStatus];
}
